import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("mr_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Normalise error payloads so callers can safely render `err.response.data.detail`.
// Pydantic 422 returns detail as an array of {loc, msg, type} — passing that to React
// (e.g. via toast.error()) crashes the whole tree with "Objects are not valid as a React child".
export const formatApiError = (err, fallback = "Request failed") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map(e => {
      const loc = Array.isArray(e?.loc) ? e.loc.filter(x => x !== "body").join(".") : "";
      return loc ? `${loc}: ${e?.msg || "invalid"}` : (e?.msg || "invalid");
    }).join(" · ");
  }
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return String(d);
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Freeze a safe string on the error so any legacy `err.response.data.detail`
    // caller receives a string instead of a Pydantic array/object.
    if (err?.response?.data && err.response.data.detail && typeof err.response.data.detail !== "string") {
      err.response.data.detail = formatApiError(err);
    }
    return Promise.reject(err);
  }
);

export default api;
export const fileUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);
